export default __webpack_public_path__ + "static/media/pgstats-logo.93a87dcc.svg";